<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper worldEnded" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal worldEnd worldEnded">
					<div class="modalContent">
						
						<div class="endOfWorldDecoration endOfWorld_windowHeader_large_illu contentHeader">
							<h2 class="msAntiScroll">
								<span>Конец игры</span>
							</h2>
						</div>
						<div class="functionPanel">
							<a ng-if="w.params.modalParams.closeable" class="closeWindow clickable"  play-on-click="7" @click="$router.push('/township')" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="closeWindow" :class="{'action_cancel_small_flat_black': !cancelHover, 'action_cancel_small_flat_green': cancelHover}" @mouseover="cancelHover = true" @mouseleave="cancelHover = false"></i>
							</a>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<nav class="tabulation  maintab unselectable">
									<a class="tab clickable" :class="{active: tab == 'world-wonder', inactive: tab != 'world-wonder'}" @click="onToggleTab('world-wonder')">
										<div class="content">
											<span>Чудо света</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'victory-points-ranking', inactive: tab != 'victory-points-ranking'}" @click="onToggleTab('victory-points-ranking')">
										<div class="content">
											<span>Победные очки</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'kingdom-ranking', inactive: tab != 'kingdom-ranking'}" @click="onToggleTab('kingdom-ranking')">
										<div class="content">
											<span>Рейтинг королевств</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'player-ranking', inactive: tab != 'player-ranking'}" @click="onToggleTab('player-ranking')">
										<div class="content">
											<span>Рейтинг игроков</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'prestige', inactive: tab != 'prestige'}" @click="onToggleTab('prestige')">
										<div class="content">
											<span>Престиж</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable scrollingDisabled tabContentWorldWonder">
									<div class="scrollContentOuterWrapper disableScrolling">
										<div class="scrollContent disableScrolling" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div class="statistics">
													<div class="loadedTab currentTab" v-if="tab == 'world-wonder'">
														<div ng-repeat="r in [1,2,3,4,5,6,7]" class="rankingEntryBox rank1">
	<i class="header endOfWorld_wwPlace1_large_illu">
		<div class="number rank1">1</div>
	</i>
	<!-- ngIf: worldWonders[$index].playerId >= 100 --><div class="content" ng-if="worldWonders[$index].playerId >= 100">
		<div class="headerRow">
			<span translate="" data="bonus: 50"><span>Бонус: </span><i class="icon symbol_bonus_small_flat"></i><span> &#x202D;&#x202D;50&#x202C;%&#x202C;</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="level">
			<span translate="" data="level: 100"><span>Уровень здания: 100</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="alliance">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20">Медоеды</a>
		</div>
		<div class="horizontalLine"></div>
		<div class="player">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="220" playername="TiS">TiS</a>
		</div>
	</div><!-- end ngIf: worldWonders[$index].playerId >= 100 -->

	<!-- ngIf: worldWonders[$index].playerId < 100 -->
</div><!-- end ngRepeat: r in [1,2,3,4,5,6,7] --><div ng-repeat="r in [1,2,3,4,5,6,7]" class="rankingEntryBox rank2">
	<i class="header endOfWorld_wwPlace2_large_illu">
		<div class="number rank2">2</div>
	</i>
	<!-- ngIf: worldWonders[$index].playerId >= 100 --><div class="content" ng-if="worldWonders[$index].playerId >= 100">
		<div class="headerRow">
			<span translate="" data="bonus: 33"><span>Бонус: </span><i class="icon symbol_bonus_small_flat"></i><span> &#x202D;&#x202D;33&#x202C;%&#x202C;</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="level">
			<span translate="" data="level: 98"><span>Уровень здания: 98</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="alliance">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20">Медоеды</a>
		</div>
		<div class="horizontalLine"></div>
		<div class="player">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="171" playername="Неясыть">Неясыть</a>
		</div>
	</div><!-- end ngIf: worldWonders[$index].playerId >= 100 -->

	<!-- ngIf: worldWonders[$index].playerId < 100 -->
</div><!-- end ngRepeat: r in [1,2,3,4,5,6,7] --><div ng-repeat="r in [1,2,3,4,5,6,7]" class="rankingEntryBox rank3">
	<i class="header endOfWorld_wwPlace3_large_illu">
		<div class="number rank3">3</div>
	</i>
	<!-- ngIf: worldWonders[$index].playerId >= 100 --><div class="content" ng-if="worldWonders[$index].playerId >= 100">
		<div class="headerRow">
			<span translate="" data="bonus: 25"><span>Бонус: </span><i class="icon symbol_bonus_small_flat"></i><span> &#x202D;&#x202D;25&#x202C;%&#x202C;</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="level">
			<span translate="" data="level: 76"><span>Уровень здания: 76</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="alliance">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 41}, null, true)" kingdomid="41">DOTA2</a>
		</div>
		<div class="horizontalLine"></div>
		<div class="player">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="165" playername="Географ">Географ</a>
		</div>
	</div><!-- end ngIf: worldWonders[$index].playerId >= 100 -->

	<!-- ngIf: worldWonders[$index].playerId < 100 -->
</div><!-- end ngRepeat: r in [1,2,3,4,5,6,7] --><div ng-repeat="r in [1,2,3,4,5,6,7]" class="rankingEntryBox rank4">
	<i class="header endOfWorld_wwPlace4_large_illu">
		<div class="number rank4">4</div>
	</i>
	<!-- ngIf: worldWonders[$index].playerId >= 100 --><div class="content" ng-if="worldWonders[$index].playerId >= 100">
		<div class="headerRow">
			<span translate="" data="bonus: 20"><span>Бонус: </span><i class="icon symbol_bonus_small_flat"></i><span> &#x202D;&#x202D;20&#x202C;%&#x202C;</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="level">
			<span translate="" data="level: 59"><span>Уровень здания: 59</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="alliance">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20">Медоеды</a>
		</div>
		<div class="horizontalLine"></div>
		<div class="player">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="118" playername="ephbiu">ephbiu</a>
		</div>
	</div><!-- end ngIf: worldWonders[$index].playerId >= 100 -->

	<!-- ngIf: worldWonders[$index].playerId < 100 -->
</div><!-- end ngRepeat: r in [1,2,3,4,5,6,7] --><div ng-repeat="r in [1,2,3,4,5,6,7]" class="rankingEntryBox rank5">
	<i class="header endOfWorld_wwPlace4_large_illu">
		<div class="number rank5">5</div>
	</i>
	<!-- ngIf: worldWonders[$index].playerId >= 100 --><div class="content" ng-if="worldWonders[$index].playerId >= 100">
		<div class="headerRow">
			<span translate="" data="bonus: 15"><span>Бонус: </span><i class="icon symbol_bonus_small_flat"></i><span> &#x202D;&#x202D;15&#x202C;%&#x202C;</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="level">
			<span translate="" data="level: 38"><span>Уровень здания: 38</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="alliance">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" kingdomid="3">MИР</a>
		</div>
		<div class="horizontalLine"></div>
		<div class="player">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="662" playername="Migera">Migera</a>
		</div>
	</div><!-- end ngIf: worldWonders[$index].playerId >= 100 -->

	<!-- ngIf: worldWonders[$index].playerId < 100 -->
</div><!-- end ngRepeat: r in [1,2,3,4,5,6,7] --><div ng-repeat="r in [1,2,3,4,5,6,7]" class="rankingEntryBox rank6">
	<i class="header endOfWorld_wwPlace4_large_illu">
		<div class="number rank6">6</div>
	</i>
	<!-- ngIf: worldWonders[$index].playerId >= 100 --><div class="content" ng-if="worldWonders[$index].playerId >= 100">
		<div class="headerRow">
			<span translate="" data="bonus: 10"><span>Бонус: </span><i class="icon symbol_bonus_small_flat"></i><span> &#x202D;&#x202D;10&#x202C;%&#x202C;</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="level">
			<span translate="" data="level: 16"><span>Уровень здания: 16</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="alliance">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20">Медоеды</a>
		</div>
		<div class="horizontalLine"></div>
		<div class="player">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="118" playername="ephbiu">ephbiu</a>
		</div>
	</div><!-- end ngIf: worldWonders[$index].playerId >= 100 -->

	<!-- ngIf: worldWonders[$index].playerId < 100 -->
</div><!-- end ngRepeat: r in [1,2,3,4,5,6,7] --><div ng-repeat="r in [1,2,3,4,5,6,7]" class="rankingEntryBox rank7">
	<i class="header endOfWorld_wwPlace4_large_illu">
		<div class="number rank7">7</div>
	</i>
	<!-- ngIf: worldWonders[$index].playerId >= 100 --><div class="content" ng-if="worldWonders[$index].playerId >= 100">
		<div class="headerRow">
			<span translate="" data="bonus: 0"><span>Бонус: </span><i class="icon symbol_bonus_small_flat"></i><span> &#x202D;&#x202D;0&#x202C;%&#x202C;</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="level">
			<span translate="" data="level: 5"><span>Уровень здания: 5</span></span>
		</div>
		<div class="horizontalLine"></div>
		<div class="alliance">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" kingdomid="3">MИР</a>
		</div>
		<div class="horizontalLine"></div>
		<div class="player">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="131" playername="Azzuro">Azzuro</a>
		</div>
	</div><!-- end ngIf: worldWonders[$index].playerId >= 100 -->

	<!-- ngIf: worldWonders[$index].playerId < 100 -->
</div>
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'victory-points-ranking'">
														<div class="rankingEntryBox rank1 kingdom">
	<i class="header endOfWorld_alliance_rank1_large_illu"></i>
	<div class="content">
		<div class="winner"></div>
		<h6 class="headerWithArrowEndings glorious">
			<div class="content" translate=""><span>Победитель:</span></div>
		</h6>
		<div class="winnerContent">
			<div class="headerRow">
				<i class="unit_victoryPoints_small_flat_black"></i>&nbsp;20&nbsp;518&nbsp;582
			</div>
			<div class="kingdomName">
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20">Медоеды</a>
			</div>
			<div class="horizontalLine belowRank1"></div>
			<!-- ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><div class="king rank1 unitedKingdom" ng-repeat="member in victoryPoints[0].members" ng-if="member.rights > 0" ng-class="{'unitedKingdom': isKingdomUnited(victoryPoints[0].kingdomId)}">
				<div class="playerHead">
					<avatar-image scale="0.62" player-id="220" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
				</div>
				<br>
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="220">TiS</a>
			</div><!-- end ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><div class="king rank2 unitedKingdom" ng-repeat="member in victoryPoints[0].members" ng-if="member.rights > 0" ng-class="{'unitedKingdom': isKingdomUnited(victoryPoints[0].kingdomId)}">
				<div class="playerHead">
					<avatar-image scale="0.62" player-id="113" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
				</div>
				<br>
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="113">ШЕЛЕСТ</a>
			</div><!-- end ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><div class="king rank3 unitedKingdom" ng-repeat="member in victoryPoints[0].members" ng-if="member.rights > 0" ng-class="{'unitedKingdom': isKingdomUnited(victoryPoints[0].kingdomId)}">
				<div class="playerHead">
					<avatar-image scale="0.62" player-id="171" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
				</div>
				<br>
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="171">Неясыть</a>
			</div><!-- end ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><div class="king rank4 unitedKingdom" ng-repeat="member in victoryPoints[0].members" ng-if="member.rights > 0" ng-class="{'unitedKingdom': isKingdomUnited(victoryPoints[0].kingdomId)}">
				<div class="playerHead">
					<avatar-image scale="0.62" player-id="129" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
				</div>
				<br>
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="129">Pinch</a>
			</div><!-- end ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><div class="king rank5 unitedKingdom" ng-repeat="member in victoryPoints[0].members" ng-if="member.rights > 0" ng-class="{'unitedKingdom': isKingdomUnited(victoryPoints[0].kingdomId)}">
				<div class="playerHead">
					<avatar-image scale="0.62" player-id="118" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
				</div>
				<br>
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="118">ephbiu</a>
			</div><!-- end ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><div class="king rank6 unitedKingdom" ng-repeat="member in victoryPoints[0].members" ng-if="member.rights > 0" ng-class="{'unitedKingdom': isKingdomUnited(victoryPoints[0].kingdomId)}">
				<div class="playerHead">
					<avatar-image scale="0.62" player-id="157" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
				</div>
				<br>
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="157">DobroDim</a>
			</div><!-- end ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members --><!-- ngIf: member.rights > 0 --><!-- end ngRepeat: member in victoryPoints[0].members -->
			<div class="showAll">
				<div class="horizontalLine"></div>
				<span clickable="openOverlay('kingdomMemberList', {kingdomId: victoryPoints[0].kingdomId})" translate="" class="clickable" @click="windowOverlay1 = true"><span>Показать все</span></span>
			</div>
		</div>
	</div>
</div>

<!-- ngRepeat: r in [2,3] --><div ng-repeat="r in [2,3]" class="rankingEntryBox rank2 kingdom top3">
	<i class="header endOfWorld_alliance_rank2_large_illu"></i>
	<div class="content">
		<div class="headerRow">
			<i class="unit_victoryPoints_small_flat_black"></i>&nbsp;10&nbsp;413&nbsp;290
		</div>
		<div class="horizontalLine"></div>
		<div class="kingdomName truncated">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" kingdomid="3">MИР</a>
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="662">Migera</a>
			<!-- ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><div class="viceKing" ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleViceKing">
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="172">Царевич</a>
			</div><!-- end ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members -->
		</div>
		<div class="horizontalLine"></div>
		<!-- ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="847">Мерзкий Карлик</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="124">TVG</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="283">GreenFoxD</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="137">Флавий</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members -->
		<div class="horizontalLine"></div>
		<div class="showAll">
			<div class="horizontalLine"></div>
			<span clickable="openOverlay('kingdomMemberList', {kingdomId: 3 })" translate="" class="clickable" @click="windowOverlay1 = true"><span>Показать все</span></span>
		</div>
	</div>
</div><!-- end ngRepeat: r in [2,3] --><div ng-repeat="r in [2,3]" class="rankingEntryBox rank3 kingdom top3">
	<i class="header endOfWorld_alliance_rank3_large_illu"></i>
	<div class="content">
		<div class="headerRow">
			<i class="unit_victoryPoints_small_flat_black"></i>&nbsp;3&nbsp;407&nbsp;868
		</div>
		<div class="horizontalLine"></div>
		<div class="kingdomName truncated">
			<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 41}, null, true)" kingdomid="41">DOTA2</a>
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="153">Letrot</a>
			<!-- ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><div class="viceKing" ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleViceKing">
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="1521">Sand68</a>
			</div><!-- end ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleViceKing --><!-- end ngRepeat: member in victoryPoints[$index+1].members -->
		</div>
		<div class="horizontalLine"></div>
		<!-- ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="165">Географ</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="1040">пупок</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="288">Kimchick</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><div ng-repeat="member in victoryPoints[$index+1].members" ng-if="member.rights == KingdomRoleDuke">
			<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="1388">Друль</a>
		</div><!-- end ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members --><!-- ngIf: member.rights == KingdomRoleDuke --><!-- end ngRepeat: member in victoryPoints[$index+1].members -->
		<div class="horizontalLine"></div>
		<div class="showAll">
			<div class="horizontalLine"></div>
			<span clickable="openOverlay('kingdomMemberList', {kingdomId: 41 })" translate="" class="clickable" @click="windowOverlay1 = true"><span>Показать все</span></span>
		</div>
	</div>
</div>
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'kingdom-ranking'">
														<div ng-repeat="r in kingdomRankings" class="rankingEntryBox player kingdom">
	<i class="header kingdom treasures endOfWorld_deffPointsTop_large_illu" ng-class="{endOfWorld_populationTop_large_illu: r.type == 'population',
													endOfWorld_deffPointsTop_large_illu: r.type == 'treasures',
													endOfWorld_sizeTop_large_illu: r.type == 'size'}"></i>
	<div class="content">
		<div class="headerRow">
			<span translate="" options="treasures"><span>Сокровища</span></span>
		</div>
		<!-- ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="662" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				1.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" kingdomid="3" kingdomname="MИР">MИР</a>
				<div class="points">
					<i class="unit_treasure_small_flat_black"></i>138&nbsp;649
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="662" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="220" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				2.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20" kingdomname="Медоеды">Медоеды</a>
				<div class="points">
					<i class="unit_treasure_small_flat_black"></i>131&nbsp;475
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="220" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="153" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				3.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 41}, null, true)" kingdomid="41" kingdomname="DOTA2">DOTA2</a>
				<div class="points">
					<i class="unit_treasure_small_flat_black"></i>46&nbsp;675
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="153" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="502" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				4.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 78}, null, true)" kingdomid="78" kingdomname="Miledi">Miledi</a>
				<div class="points">
					<i class="unit_treasure_small_flat_black"></i>20
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="502" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking -->

		<!-- ngIf: ownKingdomRankings[r.type] != null && ownKingdomRankings[r.type].rank >= 10 -->
	</div>
</div><!-- end ngRepeat: r in kingdomRankings --><div ng-repeat="r in kingdomRankings" class="rankingEntryBox player kingdom">
	<i class="header kingdom population endOfWorld_populationTop_large_illu" ng-class="{endOfWorld_populationTop_large_illu: r.type == 'population',
													endOfWorld_deffPointsTop_large_illu: r.type == 'treasures',
													endOfWorld_sizeTop_large_illu: r.type == 'size'}"></i>
	<div class="content">
		<div class="headerRow">
			<span translate="" options="population"><span>Население</span></span>
		</div>
		<!-- ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="220" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				1.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20" kingdomname="Медоеды">Медоеды</a>
				<div class="points">
					<i class="unit_population_small_flat_black"></i>524&nbsp;306
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="220" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="662" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				2.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" kingdomid="3" kingdomname="MИР">MИР</a>
				<div class="points">
					<i class="unit_population_small_flat_black"></i>406&nbsp;034
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="662" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="153" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				3.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 41}, null, true)" kingdomid="41" kingdomname="DOTA2">DOTA2</a>
				<div class="points">
					<i class="unit_population_small_flat_black"></i>195&nbsp;817
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="153" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="502" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				4.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 78}, null, true)" kingdomid="78" kingdomname="Miledi">Miledi</a>
				<div class="points">
					<i class="unit_population_small_flat_black"></i>622
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="502" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking -->

		<!-- ngIf: ownKingdomRankings[r.type] != null && ownKingdomRankings[r.type].rank >= 10 -->
	</div>
</div><!-- end ngRepeat: r in kingdomRankings --><div ng-repeat="r in kingdomRankings" class="rankingEntryBox player kingdom">
	<i class="header kingdom size endOfWorld_sizeTop_large_illu" ng-class="{endOfWorld_populationTop_large_illu: r.type == 'population',
													endOfWorld_deffPointsTop_large_illu: r.type == 'treasures',
													endOfWorld_sizeTop_large_illu: r.type == 'size'}"></i>
	<div class="content">
		<div class="headerRow">
			<span translate="" options="size"><span>Площадь</span></span>
		</div>
		<!-- ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="220" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				1.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 20}, null, true)" kingdomid="20" kingdomname="Медоеды">Медоеды</a>
				<div class="points">
					<i class="unit_influence_small_flat_black"></i>1&nbsp;117
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="220" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="662" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				2.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 3}, null, true)" kingdomid="3" kingdomname="MИР">MИР</a>
				<div class="points">
					<i class="unit_influence_small_flat_black"></i>1&nbsp;109
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="662" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="153" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				3.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 41}, null, true)" kingdomid="41" kingdomname="DOTA2">DOTA2</a>
				<div class="points">
					<i class="unit_influence_small_flat_black"></i>507
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="153" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="502" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				4.
				<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 78}, null, true)" kingdomid="78" kingdomname="Miledi">Miledi</a>
				<div class="points">
					<i class="unit_influence_small_flat_black"></i>37
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" playerid="502" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking -->

		<!-- ngIf: ownKingdomRankings[r.type] != null && ownKingdomRankings[r.type].rank >= 10 -->
	</div>
</div>
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'player-ranking'">
														<div ng-repeat="r in playerRankings" class="rankingEntryBox player">
	<i class="header player  endOfWorld_populationTop_large_illu"></i>
	<div class="content">
		<div class="headerRow">
			<span translate="" options="population"><span>Население</span></span>
		</div>
		<!-- ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="131" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				1.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="131" playername="Azzuro">Azzuro</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					19&nbsp;096
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="171" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				2.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="171" playername="Неясыть">Неясыть</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					15&nbsp;088
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="175" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				3.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="175" playername="zerb">zerb</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					14&nbsp;892
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="413" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				4.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="413" playername="Kharakternyk">Kharakternyk</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					14&nbsp;101
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="328" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				5.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="328" playername="PITBULL">PITBULL</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					13&nbsp;953
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="141" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				6.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="141" playername="Rita Staff">Rita Staff</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					13&nbsp;347
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="129" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				7.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="129" playername="Pinch">Pinch</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					13&nbsp;231
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="124" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				8.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="124" playername="TVG">TVG</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					12&nbsp;664
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="220" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				9.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="220" playername="TiS">TiS</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					12&nbsp;606
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="157" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				10.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="157" playername="DobroDim">DobroDim</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					12&nbsp;579
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking -->

		<!-- ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 --><div class="entry own" ng-if="ownRankings[r.type] != null &amp;&amp; ownRankings[r.type].rank >= 10">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="734" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				209.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="734" playername="lexinzector">lexinzector</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' --><i class="unit_population_small_flat_black" ng-if="r.type == 'population'"></i><!-- end ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					2&nbsp;708
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="ownRankings[r.type].stars" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 -->
	</div>
</div><!-- end ngRepeat: r in playerRankings --><div ng-repeat="r in playerRankings" class="rankingEntryBox player">
	<i class="header player  endOfWorld_offPointsTop_large_illu"></i>
	<div class="content">
		<div class="headerRow">
			<span translate="" options="offPoints"><span>Нападение</span></span>
		</div>
		<!-- ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="118" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				1.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="118" playername="ephbiu">ephbiu</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					601&nbsp;054
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="220" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				2.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="220" playername="TiS">TiS</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					597&nbsp;746
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="129" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				3.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="129" playername="Pinch">Pinch</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					507&nbsp;012
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="161" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				4.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="161" playername="kapik">kapik</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					449&nbsp;806
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="113" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				5.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="113" playername="ШЕЛЕСТ">ШЕЛЕСТ</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					407&nbsp;510
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="128" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				6.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="128" playername="Gugulma">Gugulma</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					389&nbsp;319
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="158" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				7.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="158" playername="Гетайры">Гетайры</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					387&nbsp;685
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="710" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				8.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="710" playername="Алешенька">Алешенька</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					378&nbsp;547
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="130" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				9.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="130" playername="Klaus">Klaus</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					376&nbsp;081
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="165" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				10.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="165" playername="Географ">Географ</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					366&nbsp;989
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking -->

		<!-- ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 --><div class="entry own" ng-if="ownRankings[r.type] != null &amp;&amp; ownRankings[r.type].rank >= 10">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="734" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				223.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="734" playername="lexinzector">lexinzector</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' --><i class="movement_attack_small_flat_black" ng-if="r.type == 'offPoints'"></i><!-- end ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					1&nbsp;842
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="ownRankings[r.type].stars" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 -->
	</div>
</div><!-- end ngRepeat: r in playerRankings --><div ng-repeat="r in playerRankings" class="rankingEntryBox player">
	<i class="header player  endOfWorld_deffPointsTop_large_illu"></i>
	<div class="content">
		<div class="headerRow">
			<span translate="" options="deffPoints"><span>Оборона</span></span>
		</div>
		<!-- ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="171" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				1.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="171" playername="Неясыть">Неясыть</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					648&nbsp;054
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="131" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				2.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="131" playername="Azzuro">Azzuro</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					596&nbsp;442
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="117" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				3.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="117" playername="Stavred">Stavred</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					564&nbsp;813
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="124" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				4.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="124" playername="TVG">TVG</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					359&nbsp;299
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="662" class="avatar"><!-- rerender: rerender --><div class="heroImage  female" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				5.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="662" playername="Migera">Migera</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					333&nbsp;170
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="1485" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				6.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="1485" playername="Грабитель">Грабитель</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					291&nbsp;571
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="103" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				7.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="103" playername="Грибница">Грибница</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					262&nbsp;222
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="158" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				8.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="158" playername="Гетайры">Гетайры</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					260&nbsp;474
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="847" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				9.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="847" playername="Мерзкий Карлик">Мерзкий Карлик</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					211&nbsp;077
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="225" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				10.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="225" playername="Данил">Данил</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					208&nbsp;387
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking -->

		<!-- ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 --><div class="entry own" ng-if="ownRankings[r.type] != null &amp;&amp; ownRankings[r.type].rank >= 10">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="734" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				214.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="734" playername="lexinzector">lexinzector</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' --><i class="movement_defend_small_flat_black" ng-if="r.type == 'deffPoints'"></i><!-- end ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' -->
					2&nbsp;542
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="ownRankings[r.type].stars" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 -->
	</div>
</div><!-- end ngRepeat: r in playerRankings --><div ng-repeat="r in playerRankings" class="rankingEntryBox player">
	<i class="header player  endOfWorld_heroesTop_large_illu"></i>
	<div class="content">
		<div class="headerRow">
			<span translate="" options="heroes"><span>Герои</span></span>
		</div>
		<!-- ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="124" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				1.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="124" playername="TVG">TVG</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					1&nbsp;136&nbsp;188
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="158" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				2.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="158" playername="Гетайры">Гетайры</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					1&nbsp;056&nbsp;825
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="117" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				3.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="117" playername="Stavred">Stavred</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					1&nbsp;041&nbsp;954
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="157" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				4.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="157" playername="DobroDim">DobroDim</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					981&nbsp;139
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="131" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				5.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="131" playername="Azzuro">Azzuro</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					962&nbsp;532
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="118" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				6.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="118" playername="ephbiu">ephbiu</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					938&nbsp;761
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="129" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				7.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="129" playername="Pinch">Pinch</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					890&nbsp;278
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="171" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				8.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="171" playername="Неясыть">Неясыть</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					806&nbsp;634
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_bronzeBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="553" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				9.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="553" playername="Труррль">Труррль</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					778&nbsp;944
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
		<i class="prestigeStar prestige_starGold_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking --><div class="entry" ng-repeat="entry in r.ranking">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="165" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				10.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="165" playername="Географ">Географ</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					772&nbsp;858
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="entry.stars" size="tiny">
	<!-- ngIf: !badge -->
	<!-- ngIf: badge --><i ng-if="badge" class="prestigeBadge prestige_silverBadge_tiny_illu"></i><!-- end ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngRepeat: entry in r.ranking -->

		<!-- ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 --><div class="entry own" ng-if="ownRankings[r.type] != null &amp;&amp; ownRankings[r.type].rank >= 10">
			<div class="horizontalLine"></div>
			<div class="playerHead">
				<avatar-image scale="0.62" player-id="734" class="avatar"><!-- rerender: rerender --><div class="heroImage  male" ng-class="::class" rerender="rerender">
	<!-- ngIf: playerId == robberId -->
	<!-- ngIf: playerId == npcGovernorId -->
<canvas width="77" height="77"></canvas></div>
</avatar-image>
			</div>
			<div class="data truncated">
				221.
				<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="734" playername="lexinzector">lexinzector</a>
				<div class="points">
					<!-- ngIf: r.type == 'population' -->
					<!-- ngIf: r.type == 'offPoints' -->
					<!-- ngIf: r.type == 'deffPoints' -->
					<!-- ngIf: r.type == 'heroes' --><i class="symbol_star_tiny_illu" ng-if="r.type == 'heroes'"></i><!-- end ngIf: r.type == 'heroes' -->
					28&nbsp;908
				</div>
			</div>
			<!-- ngIf: config.balancing.features.prestige --><div class="endGamePrestigeStars" ng-if="config.balancing.features.prestige" content="Престиж (ранг)" v-tippy="{placement: 'bottom'}" tooltip-translate="Prestige.Level">
				<div class="innerStars" stars="ownRankings[r.type].stars" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
			</div><!-- end ngIf: config.balancing.features.prestige -->
		</div><!-- end ngIf: ownRankings[r.type] != null && ownRankings[r.type].rank >= 10 -->
	</div>
</div>
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'prestige'">
														<div class="worldEndPrestige">
	<div class="prestigeSummary">
		<div class="header">
		</div>
		<div class="content summaryContent">
			<div class="summaryValues">
				<span translate="" class="summaryCongratulationsTextContainer" data="prestige:104,serverName:RU4"><strong>ПОЗДРАВЛЯЕМ</strong><span>, ты заработал </span><strong>104</strong><span> престижа в игровом мире </span><strong>RU4</strong></span>
				<div class="horizontalLine"></div>
				<div class="summarySections" ng-class="{'wwPrestigeShown': prestige.wwPrestige}">
					<div class="weeklyPrestige">
						104
						<br>
						<span translate=""><span>Престиж за неделю</span></span>
					</div>
					<div class="bonusPrestige">
						&lrm;&#x202D;+&#x202D;0&#x202C;%&#x202C;
						<br>
						<span translate=""><span>Бонус за рейтинг</span></span>
					</div>
					<!-- ngIf: prestige.wwPrestige -->
					<div class="totalPrestige">
						<b>104</b>
					</div>
				</div>
			</div>
			<div class="summaryChaplet">
				<div class="report_chaplet_big_illu"></div>
				<div class="prestigeStars">
					<div class="innerStars" playerid="734" size="tiny">
	<!-- ngIf: !badge --><div ng-if="!badge">
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
		<i class="prestigeStar prestige_starSilver_tiny_illu"></i>
	</div><!-- end ngIf: !badge -->
	<!-- ngIf: badge -->
</div>
				</div>
				<!-- ngIf: config.balancing.features.prestige --><div class="prestigeStarsTooltip clickable" content="Сейчас у тебя 485 престижа. Для следующего уровня необходимо 500 престижа." v-tippy="{placement: 'bottom'}" tooltip-translate-switch="{
						'Prestige.Stars.Tooltip.Own': true,
						'Prestige.Stars.Tooltip.Own.Max': false
					 }" ng-if="config.balancing.features.prestige" clickable="openWindow('profile', {'playerId': playerId, 'profileTab': 'prestige'})" tooltip-data="prestige:485,nextLevelPrestige:500"></div><!-- end ngIf: config.balancing.features.prestige -->
			</div>
		</div>
	</div>

	<div class="clear"></div>

	<div class="rankingEntryBox prestigeWw" ng-class="{'hidden': !prestige.wwPrestige}">
		<div class="header prestigeCup report_cup_big_illu">
			<div class="points">&lrm;&#x202D;+&#x202D;0&#x202C;&#x202C;</div>
		</div>
		<div class="content">
			<div class="rankingTitle" translate=""><span>Чудо света</span></div>
			<div class="horizontalLine"></div>
			<div>
				<!-- ngIf: wwVillageCount <= 1 --><!-- ngIf: wwVillageCount > 1 -->
			</div>
			<div class="horizontalLine"></div>
			<div :content="tooltips[5]" v-tippy="{placement: 'bottom'}" tooltip-url="tpl/worldEnded/partials/bonusTooltip.html" tooltip-data="custom:true,customText:За каждый уровень Чуда света ты получаешь 1 очко престижа.,title:WorldEndPrestige.Tooltip.wwTitle,prestigeAmount:0">
				<i class="feature_prestige_small_flat_black bonusPrestigeCupIcon"></i><span translate=""><span>Бонус: </span></span>0
			</div>
		</div>
	</div>

	<div class="clear"></div>

	<div class="rankingEntryBox">
		<div class="header prestigeCup report_cup_big_illu">
			<div class="points">&lrm;&#x202D;+&#x202D;0&#x202C;&#x202C;</div>
		</div>
		<div class="content">
			<div class="rankingTitle" translate=""><span>Королевство</span></div>
			<div class="horizontalLine"></div>
			<div>
				<span translate=""><span>Ранг: </span></span>
				<!-- ngIf: prestige.kingdomRank >= 0 -->
				<!-- ngIf: prestige.kingdomRank == -1 --><span ng-if="prestige.kingdomRank == -1"> - </span><!-- end ngIf: prestige.kingdomRank == -1 -->
			</div>
			<div class="horizontalLine"></div>
			<div :content="tooltips[1]" v-tippy="{placement: 'top'}" tooltip-url="tpl/worldEnded/partials/bonusTooltip.html" tooltip-data="custom:true,customText:Ты не являешься жителем королевства.,title:WorldEndPrestige.Tooltip.KingdomTitle,prestigeAmount:0,bonusPercent:0">
				<i class="feature_prestige_small_flat_black bonusPrestigeCupIcon"></i><span translate=""><span>Бонус: </span></span>&lrm;&#x202D;&#x202D;0&#x202C;%&#x202C;
			</div>
		</div>
	</div>
	<div class="rankingEntryBox">
		<div class="header prestigeCup report_cup_big_illu">
			<div class="points">&lrm;&#x202D;+&#x202D;0&#x202C;&#x202C;</div>
		</div>
		<div class="content">
			<div class="rankingTitle" translate=""><span>Население</span></div>
			<div class="horizontalLine"></div>
			<div>
				<span translate=""><span>Ранг: </span></span>
				<!-- ngIf: prestige.populationRank >= 0 --><span ng-if="prestige.populationRank >= 0">209</span><!-- end ngIf: prestige.populationRank >= 0 -->
				<!-- ngIf: prestige.populationRank == -1 -->
			</div>
			<div class="horizontalLine"></div>
			<div :content="tooltips[2]" v-tippy="{placement: 'top'}" tooltip-url="tpl/worldEnded/partials/bonusTooltip.html" tooltip-data="title:WorldEndPrestige.Tooltip.PopulationTitle,prestigeAmount:0,bonusPercent:0">
				<i class="feature_prestige_small_flat_black bonusPrestigeCupIcon"></i><span translate=""><span>Бонус: </span></span>&lrm;&#x202D;&#x202D;0&#x202C;%&#x202C;
			</div>
		</div>
	</div>
	<div class="rankingEntryBox">
		<div class="header prestigeCup report_cup_big_illu">
			<div class="points">&lrm;&#x202D;+&#x202D;0&#x202C;&#x202C;</div>
		</div>
		<div class="content">
			<div class="rankingTitle" translate=""><span>Нападение</span></div>
			<div class="horizontalLine"></div>
			<div>
				<span translate=""><span>Ранг: </span></span>
				<!-- ngIf: prestige.attackerRank >= 0 --><span ng-if="prestige.attackerRank >= 0">223</span><!-- end ngIf: prestige.attackerRank >= 0 -->
				<!-- ngIf: prestige.attackerRank == -1 -->
			</div>
			<div class="horizontalLine"></div>
			<div :content="tooltips[3]" v-tippy="{placement: 'top'}" tooltip-url="tpl/worldEnded/partials/bonusTooltip.html" tooltip-data="title:WorldEndPrestige.Tooltip.AttackerTitle,prestigeAmount:0,bonusPercent:0">
				<i class="feature_prestige_small_flat_black bonusPrestigeCupIcon"></i> <span translate=""><span>Бонус: </span></span>&lrm;&#x202D;&#x202D;0&#x202C;%&#x202C;
			</div>
		</div>
	</div>
	<div class="rankingEntryBox">
		<div class="header prestigeCup report_cup_big_illu">
			<div class="points">&lrm;&#x202D;+&#x202D;0&#x202C;&#x202C;</div>
		</div>
		<div class="content">
			<div class="rankingTitle" translate=""><span>Оборона</span></div>
			<div class="horizontalLine"></div>
			<div>
				<span translate=""><span>Ранг: </span></span>
				<!-- ngIf: prestige.defenderRank >= 0 --><span ng-if="prestige.defenderRank >= 0">214</span><!-- end ngIf: prestige.defenderRank >= 0 -->
				<!-- ngIf: prestige.defenderRank == -1 -->
			</div>
			<div class="horizontalLine"></div>
			<div :content="tooltips[4]" v-tippy="{placement: 'top'}" tooltip-url="tpl/worldEnded/partials/bonusTooltip.html" tooltip-data="title:WorldEndPrestige.Tooltip.DefenderTitle,prestigeAmount:0,bonusPercent:0">
				<i class="feature_prestige_small_flat_black bonusPrestigeCupIcon"></i> <span translate=""><span>Бонус: </span></span>&lrm;&#x202D;&#x202D;0&#x202C;%&#x202C;
			</div>
		</div>
	</div>
</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay">
							
							<div ng-if="overlayController" class="windowOverlay" id="kingdomMemberList" ng-controller="overlayController" v-if="windowOverlay1">
	<div class="darkener clickable" clickable="closeOverlay()"></div>
	<!-- ngInclude:  --><div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="652"><div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
	<div class="inWindowPopupHeader">
		<!-- ngIf: overlayConfig['inWindowPopupTitle'] != '' -->
		<!-- ngIf: overlayConfig['inWindowPopupTitleText'] != '' --><h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4><!-- end ngIf: overlayConfig['inWindowPopupTitleText'] != '' -->
		<a class="closeOverlay clickable" clickable="closeOverlay()" translate="" @click="windowOverlay1 = false"><span>Закрыть</span></a>
	</div>
	<div class="inWindowPopupContent">
		<!-- ngInclude:  --><div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']"><div pagination="" display-page-func="displayCurrentPage" startup-position="" items-per-page="itemsPerPage" number-of-items="numberOfItems" current-page="currentPage" route-named-param="cp"><div ng-transclude="">
	<table class="memberTable">
		<thead>
			<tr class="member">
				<th translate="" colspan="2"><span>Игрок</span></th>
				<th class="villages"><i class="village_village_small_flat_black" tooltip="" tooltip-translate="Villages"></i></th>
				<th class="population"><i class="unit_population_small_flat_black" tooltip="" tooltip-translate="Population"></i></th>
			</tr>
		</thead>
		<tbody>
			<!-- ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					1.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="171" playername="Неясыть">Неясыть</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">12</span>
				</td>
				<td class="population">
					<span class="content">15&nbsp;088</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					2.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="175" playername="zerb">zerb</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">20</span>
				</td>
				<td class="population">
					<span class="content">14&nbsp;892</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					3.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="413" playername="Kharakternyk">Kharakternyk</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">11</span>
				</td>
				<td class="population">
					<span class="content">14&nbsp;101</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					4.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="328" playername="PITBULL">PITBULL</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">9</span>
				</td>
				<td class="population">
					<span class="content">13&nbsp;953</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					5.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="141" playername="Rita Staff">Rita Staff</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">10</span>
				</td>
				<td class="population">
					<span class="content">13&nbsp;347</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					6.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="129" playername="Pinch">Pinch</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">11</span>
				</td>
				<td class="population">
					<span class="content">13&nbsp;231</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					7.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="220" playername="TiS">TiS</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">12</span>
				</td>
				<td class="population">
					<span class="content">12&nbsp;606</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					8.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="157" playername="DobroDim">DobroDim</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">11</span>
				</td>
				<td class="population">
					<span class="content">12&nbsp;579</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					9.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="118" playername="ephbiu">ephbiu</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">11</span>
				</td>
				<td class="population">
					<span class="content">12&nbsp;168</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					10.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="949" playername="Vit02">Vit02</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">8</span>
				</td>
				<td class="population">
					<span class="content">12&nbsp;128</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					11.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="161" playername="kapik">kapik</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">10</span>
				</td>
				<td class="population">
					<span class="content">10&nbsp;895</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					12.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="202" playername="Годзилла">Годзилла</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">10</span>
				</td>
				<td class="population">
					<span class="content">10&nbsp;751</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					13.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="113" playername="ШЕЛЕСТ">ШЕЛЕСТ</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">8</span>
				</td>
				<td class="population">
					<span class="content">10&nbsp;720</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					14.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="675" playername="Vladimir">Vladimir</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">10</span>
				</td>
				<td class="population">
					<span class="content">10&nbsp;504</span>
				</td>
			</tr><!-- end ngRepeat: m in members --><tr ng-repeat="m in members" class="member">
				<td class="rank">
					15.
				</td>
				<td class="playerName">
					<div class="longTitle">
						<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="136" playername="Kahau">Kahau</a>
					</div>
				</td>
				<td class="villages">
					<span class="content">8</span>
				</td>
				<td class="population">
					<span class="content">10&nbsp;324</span>
				</td>
			</tr><!-- end ngRepeat: m in members -->
		</tbody>
	</table>
</div>
<div class="tg-pagination" ng-show="visible">
	<ul>
		<li class="firstPage clickable disabled" ng-class="{disabled: currentPage == 1}" clickable="firstPage()" on-pointer-over="beginningHover = true" on-pointer-out="beginningHover = false">
			<i ng-class="{
				action_toBeginning_tiny_flat_black: !beginningHover || (beginningHover &amp;&amp; currentPage == 1),
				action_toBeginning_tiny_flat_green: beginningHover &amp;&amp; currentPage != 1,
				disabled: currentPage == 1
			}" class="action_toBeginning_tiny_flat_black disabled"></i>
		</li>
		<li class="prevPage clickable disabled" ng-class="{disabled: currentPage == 1}" clickable="prevPage()" on-pointer-over="fromHover = true" on-pointer-out="fromHover = false">
			<i ng-class="{
				symbol_arrowFrom_tiny_flat_black: !fromHover || (fromHover &amp;&amp; currentPage == 1),
				symbol_arrowFrom_tiny_flat_green: fromHover &amp;&amp; currentPage != 1,
				disabled: currentPage == 1
			}" class="symbol_arrowFrom_tiny_flat_black disabled"></i>
		</li>
		<!-- ngRepeat: pageNumber in filteredPageNumbers track by $index --><li class="number clickable disabled" ng-repeat="pageNumber in filteredPageNumbers track by $index" ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" clickable="setPage(1)">
			<a ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" class="disabled">1</a>
		</li><!-- end ngRepeat: pageNumber in filteredPageNumbers track by $index --><li class="number clickable" ng-repeat="pageNumber in filteredPageNumbers track by $index" ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" clickable="setPage(2)">
			<a ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}">2</a>
		</li><!-- end ngRepeat: pageNumber in filteredPageNumbers track by $index --><li class="number clickable disabled" ng-repeat="pageNumber in filteredPageNumbers track by $index" ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" clickable="setPage(...)">
			<a ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" class="disabled">...</a>
		</li><!-- end ngRepeat: pageNumber in filteredPageNumbers track by $index --><li class="number clickable" ng-repeat="pageNumber in filteredPageNumbers track by $index" ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" clickable="setPage(6)">
			<a ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}">6</a>
		</li><!-- end ngRepeat: pageNumber in filteredPageNumbers track by $index -->
		<li class="nextPage clickable" ng-class="{disabled: disableNext()}" on-pointer-over="toHover = true" on-pointer-out="toHover = false" clickable="nextPage()">
			<i ng-class="{
				symbol_arrowTo_tiny_flat_black: !toHover || (toHover &amp;&amp; disableNext()),
				symbol_arrowTo_tiny_flat_green: toHover &amp;&amp; !disableNext(),
				disabled: disableNext()
			}" class="symbol_arrowTo_tiny_flat_black"></i>
		</li>
		<li class="lastPage clickable" ng-class="{disabled: disableNext()}" on-pointer-over="endHover = true" on-pointer-out="endHover = false" clickable="lastPage()">
			<i ng-class="{
				action_toEnd_tiny_flat_black: !endHover || (endHover &amp;&amp; disableNext()),
				action_toEnd_tiny_flat_green: endHover &amp;&amp; !disableNext(),
				disabled: disableNext()
			}" class="action_toEnd_tiny_flat_black"></i>
		</li>
	</ul>
</div></div>
</div>
	</div>
</div></div>
</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'WorldEnded | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		tab: 'world-wonder',
		windowOverlay1: false,
		
		villageBackgroundLeft: '0px',
		
		tooltips: {
			1: `<div class="worldEndPrestigeBonusTooltip">
	<span translate="" options="WorldEndPrestige.Tooltip.KingdomTitle" data="prestige:0"><strong>Королевство (очки победы)</strong><span> - 0 престижа</span></span>
	<div class="horizontalLine"></div>
	<div ng-if="custom == 'true'">
		Ты не являешься жителем королевства.
	</div>
</div>`,
			2: `<div class="worldEndPrestigeBonusTooltip">
	<span translate="" options="WorldEndPrestige.Tooltip.PopulationTitle" data="prestige:0"><strong>Наеление</strong><span> - 0 prestige</span></span>
	<div class="horizontalLine"></div>
	<div ng-if="custom != 'true'">
		<span translate="" data="percent:0"><span>За свой рейтинг в игре ты получаешь бонус в разере 0% от твоего "еженедельного" престижа.</span></span>
	</div>
</div>`,
			3: `<div class="worldEndPrestigeBonusTooltip">
	<span translate="" options="WorldEndPrestige.Tooltip.AttackerTitle" data="prestige:0"><strong>Атакующий</strong><span> - 0 престижа</span></span>
	<div class="horizontalLine"></div>
	<div ng-if="custom != 'true'">
		<span translate="" data="percent:0"><span>За свой рейтинг в игре ты получаешь бонус в разере 0% от твоего "еженедельного" престижа.</span></span>
	</div>
</div>`,
			4: `<div class="worldEndPrestigeBonusTooltip">
	<span translate="" options="WorldEndPrestige.Tooltip.DefenderTitle" data="prestige:0"><strong>Обороняющийся</strong><span> - 0 престижа</span></span>
	<div class="horizontalLine"></div>
	<div ng-if="custom != 'true'">
		<span translate="" data="percent:0"><span>За свой рейтинг в игре ты получаешь бонус в разере 0% от твоего "еженедельного" престижа.</span></span>
	</div>
</div>`,
			5: `<div class="worldEndPrestigeBonusTooltip">
	<span translate="" options="WorldEndPrestige.Tooltip.wwTitle" data="prestige:0"><strong>Чудо света</strong><span> - 0 престижа</span></span>
	<div class="horizontalLine"></div>
	<div ng-if="custom == 'true'">
		За каждый уровень Чуда света ты получаешь 1 очко престижа.
	</div>
</div>`,
		},
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab, push = true){
			this.tab = tab;
			if(push) this.$router.push({query: {tab}});
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: {tab: 'world-wonder'}});
		else if(to.query.tab != this.tab) this.onToggleTab(to.query.tab, false);
		next();
	},
	created(){
		this.gameModel.buildingQueueShow = true;
	},
	components: {},
}
</script>